import { Badge, Tooltip } from '@mantine/core';
import { BADGE_DISPLAY } from '@/constants/badges';

interface UserBadgeProps {
  badge: string;
}

export function UserBadge({ badge }: UserBadgeProps) {
  const badgeConfig = BADGE_DISPLAY[badge];
  
  if (!badgeConfig) return null;
  
  return (
    <Tooltip 
      label={badgeConfig.description}
      multiline
      w={240}
      withArrow
      position="bottom"
      transitionProps={{ transition: 'fade', duration: 200 }}
    >
      <Badge
        variant="outline"
        size="xs"
        color={badgeConfig.color}
        styles={{
          root: { 
            paddingLeft: 8, 
            paddingRight: 8, 
            cursor: 'help',
            backgroundColor: 'white',
          },
          label: { fontWeight: 600 },
        }}
      >
        {badgeConfig.icon} {badgeConfig.label}
      </Badge>
    </Tooltip>
  );
}
